import React from 'react';
import { Round } from '.';
import { answerScoreStyle } from './AnswerGrid';

const ScoreSummary = ({
	roundSummary,
	score,
}: {
	roundSummary: Round[];
	score: number;
}) => (
	<div>
		{roundSummary.map((roundData) => {
			const { query, score } = roundData;
			return (
				<div
					key={query}
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						margin: 'var(--single)',
					}}>
					<div
						style={{
							fontSize: '16px',
						}}>
						{query}
					</div>
					<div
						style={{
							...answerScoreStyle,
							color: 'var(--blue)',
						}}>
						{score.toLocaleString()}
					</div>
				</div>
			);
		})}
		<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
			<div
				style={{
					...answerScoreStyle,
					marginRight: 'var(--single)',
				}}>
				Total:
			</div>
			<div
				style={{
					...answerScoreStyle,
					color: 'var(--pink)',
					marginRight: 'var(--single)',
				}}>
				{score.toLocaleString()}
			</div>
		</div>
	</div>
);

export default ScoreSummary;
